import { Component, OnInit } from '@angular/core';
import { environment as env } from '../../../../environments/environment'
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'simple-navbar',
    templateUrl: './simple_navbar.component.html',
    styleUrls: ['./simple_navbar.component.scss']
})
export class SimpleNavbarComponent implements OnInit {

    env;
    array_lenguage = env.array_lenguage;
    array_lenguage_name = env.array_lenguage_name;
    flag_select = env.language_default;

    constructor(
        public translate: TranslateService
    ) { }

    ngOnInit(): void {
        this.env = env.url_framer;

        const lenguage = localStorage.getItem('lenguage');
        if (!lenguage) {
            localStorage.setItem('lenguage', this.flag_select);
        }
        else {
            this.flag_select = lenguage;
        }

        this.translate.use(this.flag_select);
    }

    getLanguageName(language: any) {
        return this.array_lenguage_name[language];
    }

    changeLanguage(language:any){
        env.language_default = language
        this.flag_select = language
        localStorage.setItem('lenguage', this.flag_select);
        this.translate.use(this.flag_select);
    }

}
